/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useMemo } from 'react';

import { useAuthStore } from 'src/auth/auth.store';
import { VITE_API_URL } from 'src/config-global';
import { AxiosHttpClient } from 'src/http';

const AxiosClientContext = createContext<AxiosHttpClient | undefined>(undefined);

export const AxiosClientProvider = ({ children }: { children: React.ReactNode }) => {
  const { accessToken, refreshToken } = useAuthStore((state) => state);
  const axiosInstance = useMemo(() => new AxiosHttpClient(VITE_API_URL), [accessToken, refreshToken]);
  return <AxiosClientContext.Provider value={axiosInstance}>{children}</AxiosClientContext.Provider>;
};

export const useAxiosClientContext = () => {
  const context = useContext(AxiosClientContext);
  if (!context) throw new Error('useAxiosClient must be used within AxiosClientProvider');
  return context;
};
